import { EducationInfo } from '../../../../../../store/workspace/types';
import DateRangeFields from '../../../components/DateRangeFields';
import { useProfileUpdate } from '../../../hooks/useProfileUpdate';
import DropDown from '../../../../../../components/DropDown';
import { ListItem } from '../../../../../../store/signUp/types';
import Modal from '../../../../../../components/Modal';
import Input from '../../../../../../components/Input';
import { degreeList } from '../../../../../../config';
import styles from './style.module.scss';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';

interface Props {
    /** The degree being edited, or `null` when a new one is added. */
    education: EducationInfo | null;
    onClose: () => void;
};

/** Adds a degree to the profile or edits one that is already on it. */
function EducationForm({ education, onClose }: Props) {
    const { profile, isSaving, saveProfile } = useProfileUpdate();

    const [to, setTo] = useState(education?.to || '');
    const [GPA, setGPA] = useState(education?.GPA || '');
    const [from, setFrom] = useState(education?.from || '');
    const [field, setField] = useState(education?.field || '');
    const [universityName, setUniversityName] = useState(education?.universityName || '');
    const [didNotFinishDegree, setDidNotFinishDegree] = useState(Boolean(education && !education.to));
    const [degree, setDegree] = useState<ListItem | null>(
        degreeList.find(i => i.title === education?.degree) || null,
    );

    const submit = async () => {
        if (!profile) return;

        const record: EducationInfo = {
            from,
            GPA,
            field,
            universityName,
            universityId: '-1',
            degree: degree?.title || '',
            id: education?.id || uuid(),
            to: didNotFinishDegree ? '' : to,
        };

        const others = profile.educationInfo.filter(i => i.id !== record.id);
        const saved = await saveProfile({ educationInfo: [...others, record] });

        if (saved) onClose();
    };

    const isIncomplete =
        !from ||
        !field ||
        !GPA ||
        !universityName ||
        (!didNotFinishDegree && !to);

    return (
        <Modal
            size='md'
            actions='confirm'
            closeFunc={onClose}
            childClassName={styles.wrapper}
            title={education ? 'Edit degree' : 'Add degree'}
            confirmButton={{
                text: 'Save',
                type: 'Primary',
                onClick: submit,
                loading: isSaving,
                disabled: isIncomplete,
            }}
        >
            <Input
                type='text'
                value={universityName}
                onChange={setUniversityName}
                label='School or university'
            />
            <DropDown
                idKey='id'
                label='Degree'
                titleKey='title'
                setItem={setDegree}
                selectedItem={degree}
                dropDownList={degreeList}
            />
            <Input
                type='text'
                value={field}
                onChange={setField}
                label='Field of study'
            />
            <Input
                type='text'
                value={`${GPA}`}
                onChange={setGPA}
                inputMode='numeric'
                label='Overal result (GPA)'
            />
            <DateRangeFields
                to={to}
                from={from}
                setTo={setTo}
                setFrom={setFrom}
                isOngoing={didNotFinishDegree}
                setIsOngoing={setDidNotFinishDegree}
                ongoingLabel='Didn’t finish the degree'
            />
        </Modal>
    );
};

export default EducationForm;
